const Carousel = () => {
  $('.carousel').each(function (index, sliderWrap) {

    var $slider = $(sliderWrap).find('.carousel__slides');
    
    $slider.slick({
      dots: true,
      appendDots: $('.slick-slider-dots'),
      arrows: false,
      speed: 300,
      infinite: true,
      centerMode: false,
      centerPadding: '0',
      slidesToShow: 3,
      autoplay: false,
      autoplaySpeed: 8000,
      draggable: true,
      touchThreshold: 200,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.5,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            infinite: false,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.1,
            infinite: false,
          }
        }
      ]
    });

    // Custom carousel nav
    $('.prev').click(function (e) {
        e.preventDefault();
        $(this).parent().find($slider).slick('slickPrev');
    });

    $('.next').click(function (e) {
        e.preventDefault();
        $(this).parent().find($slider).slick('slickNext');
    });

  }); 

  const addZeroPad = (val) => val.toString().padStart(2, "0");

  $('.gallery').each(function (index, sliderWrap) {

      const $module = $(this);
      const $slider = $module.find(".gallery__slides");
      const $slides = $slider.find(".gallery__item");
      const $numbersElem = $module.find(".gallery__counter");
      const $totalNumElem = $module.find(".gallery__counter .gallery__amount");
      const $activeNumElem = $module.find(".gallery__counter .gallery__count");

      

      if ($slides.length) {
          $slider.on("init", function(event, slick) {
              console.log(slick.$slides.length);
              $activeNumElem.text(addZeroPad(1));
              $totalNumElem.text(addZeroPad(slick.$slides.length));
              $numbersElem.show();
            });

          $slider.on("afterChange", function(event, slick, currentSlide, nextSlide) {
              $activeNumElem.text(addZeroPad(currentSlide + 1));
          });



          $slider.slick({
              dots: false,
              arrows: false,
              speed: 700,
              infinite: false,
              centerMode: false,
              centerPadding: '0',
              slidesToShow: 1.5,
              autoplay: false,
              autoplaySpeed: 8000,
              draggable: true,
              touchThreshold: 200,
              pauseOnHover: false,
              responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1.2,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                }
              },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                }
              }
            ]
          });

      }
  }); 

  $('.js-images-item').each(function (index, sliderWrap) {
      var $slider = $(sliderWrap).find('.image__gallery');
      $slider.slick({
          dots: false,
          arrows: false,
          speed: 300,
          infinite: false,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          draggable: false,
          touchThreshold: 100,
          pauseOnHover: false,
          fade: true,
          cssEase: 'linear',
          rows: 0,
      });
  });


  $('.quote-carousel').each(function (index, sliderWrap) {
      var $slider = $(sliderWrap).find('.quote__slides');
      $slider.slick({
          dots: true,
          arrows: false,
          speed: 500,
          infinite: false,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 8000,
          draggable: false,
          touchThreshold: 100,
          pauseOnHover: false,
          fade: true,
          cssEase: 'linear',
      });
  });
}; 

export { Carousel };